import { useState, useEffect, useRef } from "react";
import "./header.css";

import NavMenu from "../../../assets/Images/Elements/Menu.svg";

export default function Header() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const headerRef = useRef(null);
  const mobheaderRef = useRef(null);

  /* Lock body scroll when mobile menu is open */
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  /* Hide navbar on scroll down and show on scroll up */
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY > lastScrollY;

      headerRef.current?.classList.toggle(
        "nav--hidden",
        scrollingDown && currentScrollY > 50
      );

      mobheaderRef.current?.classList.toggle(
        "nav--hidden",
        scrollingDown && currentScrollY > 50
      );

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="Navigationbar">

      {/* Desktop Navbar */}
      <div ref={headerRef} className="Navigationbar-Desktop">

        <div className="Navigationbar-Section-Left">
          <a href="/" id="Navigationbar-Logo">
            Adstrate
          </a>

          <div className="Navigationbar-Section-Left-Flex-Links">
            <a href="/about">About</a>
            <a href="/services">Services</a>
          </div>
        </div>

        <div className="Navigationbar-Section-Right-Flex">
          <a
            href="/contact"
            className="Navigationbar-Section-Right-Buttons Navigationbar-Contact-Sales"
          >
            Contact Sales
          </a>

          <a
            href="/quotation"
            className="Navigationbar-Section-Right-Buttons Navigationbar-Book-Appointment"
          >
            Book an Appointment
          </a>
        </div>

      </div>

      {/* Mobile Navbar */}
      <div ref={mobheaderRef} className="Navigationbar-Mobile-Icon">
        <a href="/" id="Navigationbar-Logo">
          Adstrate
        </a>

        <button
          type="button"
          className="Navigationbar-Mobile-Menu-Button"
          onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
        >
          <img src={NavMenu} alt="" />
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="Navigationbar-Mobile">
          <div className="Navigationbar-Mobile-Section">
            <a href="/about" onClick={() => setMobileMenuOpen(false)}>
              About
            </a>

            <a href="/services" onClick={() => setMobileMenuOpen(false)}>
              Services
            </a>

            <a href="/contact" onClick={() => setMobileMenuOpen(false)}>
              Contact Sales
            </a>

            <a href="/quotation" onClick={() => setMobileMenuOpen(false)}>
              Book an Appointment
            </a>
          </div>
        </div>
      )}

      {/* Promotional Announcement Bar
      <div className="Navigationbar-Announcement-Bar">
        <div className="Navigationbar-Announcement-Track">
          <span>
            BOOK AN APPOINTMENT TO SECURE YOUR OFFER
          </span>

          <span>
            LIMITED TIME OFFER 20% OFF ON ALL SERVICES!!! BOOK AN APPOINTMENT TO SECURE YOUR OFFER
          </span>

          <span>
            BOOK AN APPOINTMENT TO SECURE YOUR OFFER
          </span>

          <span>
            LIMITED TIME OFFER 20% OFF ON ALL SERVICES!!! BOOK AN APPOINTMENT TO SECURE YOUR OFFER
          </span>
        </div>
      </div>
      */}
    </header>
  );
}
